<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight - 6"
      size="small"
      :loading="loading"
      resizable
      border
      :expand-config="{ reserve: true }"
      :checkbox-config="{
        highlight: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">{{
              $l('tab_inspection_requirements') || '验货要求'
            }}</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              :disabled="disabled"
              variant="outline-success"
              @click="$emit('openEditDialog', { type: 'add' })"
              >{{ $l('dialog_title_inspection_add') || '新增验货要求' }}
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              :disabled="disabled"
              variant="outline-danger"
              @click="batchDel"
            >
              <i class="el-icon-delete"></i>
              {{ $l('INDEX.btn_delete') || '删除' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="openEditDialog('detail', row.orderInspectionCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.orderInspectionCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="openEditDialog('edit', row.orderInspectionCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="openEditDialog('copy', row.orderInspectionCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:expandContent="{ row }">
        <expandContent
          class="m-2"
          :orderInspectionCode="row.orderInspectionCode"
          :orderCode="row.orderCode"
          :disabled="disabled"
          @reload="$emit('reload')"
        />
      </template>
      <!-- <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.orderInspectionStatus === 'Y' ? 'light' : 'info'"
        >
          {{ row.v_orderInspectionStatus }}
        </el-tag>
      </template> -->
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import expandContent from './expand'
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  components: { expandContent },
  props: {
    orderCode: String,
    tableData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableHeight: 780,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openEditDialog(type, code) {
      this.$emit('openEditDialog', { type, code })
    },
    del(orderInspectionCode) {
      this.submitDel([orderInspectionCode])
    },
    batchDel() {
      const listCode = this.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.orderInspectionBatchDelApi({ listCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          message: this.$l('INDEX.tips_select_data') || '请选择需要操作的数据',
          type: 'warning',
        })
        return
      }
      if (type === 'code') return data.map((row) => row.orderInspectionCode)
      return data
    },
  },
}
</script>
